import { render, staticRenderFns } from "./PropertySubdivisionRoomsModal.vue?vue&type=template&id=062c7fcd&scoped=true&lang=pug&"
import script from "./PropertySubdivisionRoomsModal.vue?vue&type=script&lang=ts&"
export * from "./PropertySubdivisionRoomsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PropertySubdivisionRoomsModal.vue?vue&type=style&index=0&id=062c7fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c7fcd",
  null
  
)

export default component.exports